import { render, staticRenderFns } from "./QSiNo.vue?vue&type=template&id=686149f2"
import script from "./QSiNo.vue?vue&type=script&lang=js"
export * from "./QSiNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports